import tw, { styled } from 'twin.macro';

export const StyledSection = styled.section`
  ${tw`bg-ui-colours-ui1`}
  ${tw`!py-8`}
`;

export const StyledContainer = styled.div`
  ${tw`container`}
  ${tw`container-stack-context`}
  ${tw`px-2 md:px-0`}
`;

export const StyledDescriptionContainer = styled.div`
  ${tw`grid grid-cols-12`}
`;

export const StyledTitle = styled.h2`
  ${tw`font-poppins font-semi-bold`};
  ${tw`text-mobile-heading-l lg:text-display-xl text-secondary-s1 text-center`}
  ${tw`pb-2 lg:pb-3`}
  ${tw`col-span-12 lg:col-span-8 lg:col-start-3`}
`;

export const StyledBodyText = styled.div`
  ${tw`font-inter font-regular`};
  ${tw`text-body-l text-primary-p1  text-center`}
  ${tw`pb-3 lg:pb-8`};
  ${tw`col-span-12 lg:col-span-8 lg:col-start-3`}
`;

export const StyledItems = styled.div<{ hasButton: boolean }>`
  ${tw`flex flex-col gap-[20px]`}
  // NOTE auto-fit is used to accommodate up to 4 items. It was choosen instead of a 12 colums based grid to avoid conditions on the # of items.
  ${tw`lg:grid lg:[grid-template-columns: repeat(auto-fit, minmax(0, 1fr))] lg:gap-4`}
  ${({ hasButton }) => (hasButton ? tw`pb-4` : tw`pb-0`)}
`;

export const StyledButtonContainer = styled.div`
  ${tw`flex justify-center`}
`;
